<template>
  <div class="dsf-college-home full-view" :class="{ 'model-two': headerType == '3' }">
    <home-header-one
      v-if="headerType == '1'"
      :main-width="mainWidth"
      :dropdown-config="dropdownConfig"
      :custom-bts="customBts"
      :is-auto-hide-menu="isAutoHideMenu"
      :saasIogoImg="saasIogoImg"
      @dropdown-click="$emit('dropdown-click', $event)"
    />
    <home-header-two
      v-if="headerType == '2'"
      :main-width="mainWidth"
      :dropdown-config="dropdownConfig"
      :custom-bts="customBts"
      :is-auto-hide-menu="isAutoHideMenu"
      :saasIogoImg="saasIogoImg"
      @dropdown-click="$emit('dropdown-click', $event)"
    />
    <home-header-three
      v-if="headerType == '3'"
      :main-width="mainWidth"
      :dropdown-config="dropdownConfig"
      :custom-bts="customBts"
      :is-auto-hide-menu="isAutoHideMenu"
      :saasIogoImg="saasIogoImg"
      @dropdown-click="$emit('dropdown-click', $event)"
    />
    <section class="dsf-college-home-section" :style="{ 'min-width': mainWidth + 20 + 'px' }">
      <div class="min-view" :style="{ 'min-height': headerType == '1' ? 'calc(100vh - 288px)' : 'calc(100vh - 238px)' }">
        <router-view />
      </div>
    </section>
    <footer class="dsf-college-home-footer">
      <slot name="footer"></slot>
    </footer>
  </div>
</template>

<script>
import HomeHeaderOne from "./homeHeaderOne.vue";
import HomeHeaderTwo from "./homeHeaderTwo.vue";
import HomeHeaderThree from "./homeHeaderThree.vue";

export default {
  name: "DsfNcCollegeHome",
  components: {
    HomeHeaderOne,
    HomeHeaderTwo,
    HomeHeaderThree,
  },
  provide() {
    return {
      collegeRoot: this,
    };
  },
  props: {
    mainWidth: {
      type: Number,
      default: 1200,
    },
    dropdownConfig: {
      type: Array,
      default() {
        return [];
      },
    },
    logoUrl: {
      type: String,
      default: "",
    },
    searchPlaceholder: {
      type: String,
      required: true,
    },
    // 未登录状态下自定义按钮
    customBts: {
      type: Array,
      default() {
        return [];
      },
    },
    clickBefore: {
      type: Function,
      required: false,
    },
    doSearch: {
      type: Function,
      required: false,
    },
    // 未匹配到菜单时，是否自动隐藏菜单
    isAutoHideMenu: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      height: "auto",
      headerType: "0",
      indexModel: "0",
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      const loading = dsf.layer.loading();
      let sourceUrl = "/nc/saas/getSaasGropu";
      let params = {
        domainNameSimple: location.host,
      };
      dsf.http
        .get(sourceUrl, params, $$webRoot.nc)
        .done(({ success, data, message }) => {
          this.headerType = data.headTemplate || "1";
          this.indexModel = data.saasGroupPageDtoList;
          this.saasIogoImg = JSON.parse(data.logoImg || "[]");
        })
        .error(() => {
          this.headerType = data.headTemplate || "1";
          dsf.layer.pc.message("获取数据异常:" + err, false);
        })
        .always(res => {
          dsf.layer.closeLoading(loading);
        });
    },
    loaded() {
      // this.loading = false;
      this.$nextTick(() => {
        this.height = "auto";
        this.show = true;
      });
    },
    leaveHandler(el) {
      this.height = el.offsetHeight + "px";
    },
    _clickBefore(next, ...params) {
      if (this.isDesign) return;
      let res = this.clickBefore?.(...params);
      if (res && res.then) {
        res.then(r => {
          if (r !== false) {
            next(...params);
          }
        });
      } else if (res !== false) {
        next(...params);
      }
    },
  },
};
</script>
